import React from 'react';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core'

const PoluicaoCheckbox = ({name, item, handleSelectChange, handleInputText }) => {
  const names = name.split('.');
  let bloco = [];
  bloco.push(
    <FormControlLabel
      key={'formPoluicao'}
      control={
        <Checkbox
          checked={item.isChecked}
          name={item.label}
          onChange={() =>
            handleSelectChange(names[0], names[1], item)
          }
          color="primary"
        />
      }
      label={item.label}
    />
  )
  if (item.label === 'Outros') {
    bloco.push(
      <TextField
        key={'OutrosPoluição'}
        label={`Especifique ${names[1]}:`}
        name="OutrosTipos"
        required={item.isChecked=== true && item.label === 'Outros' ? true : false}
        defaultValue={item.value}
        onChange={(event) => handleInputText(event, names[0], names[1], item)}
        style={item.isChecked === false ? {display:"none"}: {}}
        color="primary"
        size="small"
        variant="outlined"
        margin="dense"
      />
    )
  }
  return bloco;
}

export default PoluicaoCheckbox;
